// Asset to Class Mappings
// Only includes assets that exist in public/Games/icons/*.png
// Names use proper spacing, imagePath uses the actual filename

export const CLASS_ASSET_MAPPINGS = {
  'Food': [
    { name: 'Burger', imagePath: 'burger' },
    { name: 'Pizza', imagePath: 'pizza' },
    { name: 'Bread', imagePath: 'bread' },
    { name: 'Cookies', imagePath: 'cookies' },
    { name: 'Chips', imagePath: 'chips' },
    { name: 'Fries', imagePath: 'fries' },
    { name: 'Lollipop', imagePath: 'lollipop' },
  ],

  'Cutlery': [
    { name: 'Fork', imagePath: 'fork' },
    { name: 'Spoon', imagePath: 'spoon' },
    { name: 'Knife', imagePath: 'knife' },
    { name: 'Chopstick', imagePath: 'chopstick' },
  ],

  'Drinks': [
    { name: 'Orange Juice', imagePath: 'orangejuice' },
    { name: 'Milk', imagePath: 'milk' },
    { name: 'Tea', imagePath: 'tea' },
  ],

  'Body parts': [
    { name: 'Ear', imagePath: 'ear' },
    { name: 'Eye', imagePath: 'eye' },
    { name: 'Nose', imagePath: 'nose' },
    { name: 'Tummy', imagePath: 'tummy' },
    { name: 'Mouth', imagePath: 'mouth' },
  ],

  'Musical Instruments': [
    { name: 'Harp', imagePath: 'harp' },
    { name: 'Violin', imagePath: 'violin' },
    { name: 'Piano', imagePath: 'piano' },
    { name: 'Guitar', imagePath: 'guitar' },
    { name: 'Drums', imagePath: 'drums' },
    { name: 'Flute', imagePath: 'flute' },
    { name: 'Tambourine', imagePath: 'tambourine' },
  ],

  'Toys': [
    { name: 'Spinning Top', imagePath: 'spinningtop' },
    { name: 'Puzzle', imagePath: 'puzzle' },
    { name: 'Blocks', imagePath: 'blocks' },
    { name: 'Doll', imagePath: 'doll' },
    { name: 'Ball', imagePath: 'ball' },
    { name: 'Rattle', imagePath: 'rattle' },
    { name: 'Kite', imagePath: 'kite' },
  ],

  'Vehicles': [
    { name: 'Boat', imagePath: 'boat' },
    { name: 'Car', imagePath: 'car' },
    { name: 'Train', imagePath: 'train' },
    { name: 'Bus', imagePath: 'bus' },
    { name: 'Truck', imagePath: 'truck' },
    { name: 'Van', imagePath: 'van' },
    { name: 'Airplane', imagePath: 'airplane' },
    { name: 'Helicopter', imagePath: 'helicopter' },
  ],

  'Letters': [
    { name: 'Z', imagePath: 'z' },
    { name: 'E', imagePath: 'e' },
    { name: 'D', imagePath: 'd' },
    { name: 'C', imagePath: 'c' },
    { name: 'B', imagePath: 'b' },
    { name: 'F', imagePath: 'f' },
  ],

  'Numbers': [
    { name: '35', imagePath: '35' },
    { name: '48', imagePath: '48' },
    { name: '10', imagePath: '10' },
    { name: '68', imagePath: '68' },
    { name: '71', imagePath: '71' },
    { name: '100', imagePath: '100' },
    { name: '2', imagePath: '2' },
  ],

  'Desserts': [
    { name: 'Brownie', imagePath: 'brownie' },
    { name: 'Ice Cream', imagePath: 'icecream' },
    { name: 'Lollipop', imagePath: 'lollipop' },
    { name: 'Marshmallow', imagePath: 'marshmallow' },
  ],

  'Places': [
    { name: 'Library', imagePath: 'library' },
    { name: 'Airport', imagePath: 'airport' },
  ],

  'Community helpers': [
    { name: 'Firefighter', imagePath: 'firefighter' },
    { name: 'Policeman', imagePath: 'policeman' },
  ],

  'Sports': [
    { name: 'Badminton', imagePath: 'badminton' },
    { name: 'Golf', imagePath: 'golf' },
    { name: 'Soccer Ball', imagePath: 'soccerball' },
  ],

  'Appliances': [
    { name: 'TV', imagePath: 'tv' },
    { name: 'Radio', imagePath: 'radio' },
    { name: 'Washing Machine', imagePath: 'washingmachine' },
    { name: 'Oven', imagePath: 'oven' },
  ],

  'Tools': [
    { name: 'Hammer', imagePath: 'hammer' },
    { name: 'Screwdriver', imagePath: 'screwdriver' },
    { name: 'Nail', imagePath: 'nail' },
    { name: 'Saw', imagePath: 'saw' },
  ],

  'Animals': [
    { name: 'Dog', imagePath: 'dog' },
    { name: 'Cat', imagePath: 'cat' },
    { name: 'Zebra', imagePath: 'zebra' },
    { name: 'Lion', imagePath: 'lion' },
    { name: 'Cow', imagePath: 'cow' },
    { name: 'Tiger', imagePath: 'tiger' },
    { name: 'Giraffe', imagePath: 'giraffe' },
    { name: 'Horse', imagePath: 'horse' },
    { name: 'Pig', imagePath: 'pig' },
    { name: 'Sheep', imagePath: 'sheep' },
    { name: 'Hamster', imagePath: 'hamster' },
    { name: 'Fox', imagePath: 'fox' },
    { name: 'Mouse', imagePath: 'mouse' },
    { name: 'Owl', imagePath: 'owl' },
    { name: 'Parrot', imagePath: 'parrot' },
    { name: 'Penguin', imagePath: 'penguin' },
    { name: 'Robin', imagePath: 'robin' },
    { name: 'Shark', imagePath: 'shark' },
    { name: 'Eagle', imagePath: 'eagle' },
  ],

  'Farm Animals': [
    { name: 'Pig', imagePath: 'pig' },
    { name: 'Sheep', imagePath: 'sheep' },
    { name: 'Cow', imagePath: 'cow' },
    { name: 'Horse', imagePath: 'horse' },
  ],

  'Zoo Animals': [
    { name: 'Tiger', imagePath: 'tiger' },
    { name: 'Lion', imagePath: 'lion' },
    { name: 'Giraffe', imagePath: 'giraffe' },
  ],

  'Pets': [
    { name: 'Dog', imagePath: 'dog' },
    { name: 'Cat', imagePath: 'cat' },
    { name: 'Hamster', imagePath: 'hamster' },
  ],

  'Insects': [
    { name: 'Beetle', imagePath: 'beetle' },
    { name: 'Ant', imagePath: 'ant' },
    { name: 'Dragonfly', imagePath: 'dragonfly' },
    { name: 'Bee', imagePath: 'bee' },
    { name: 'Butterfly', imagePath: 'butterfly' },
    { name: 'Wasp', imagePath: 'wasp' },
    { name: 'Scorpion', imagePath: 'scorpion' },
  ],

  'Shapes': [
    { name: 'Square', imagePath: 'square' },
    { name: 'Circle', imagePath: 'circle' },
    { name: 'Star', imagePath: 'star' },
    { name: 'Heart', imagePath: 'heart' },
  ],

  'Clothes': [
    { name: 'Shirt', imagePath: 'shirt' },
    { name: 'Jeans', imagePath: 'jeans' },
    { name: 'Underwear', imagePath: 'underwear' },
    { name: 'Hat', imagePath: 'hat' },
    { name: 'Jacket', imagePath: 'jacket' },
    { name: 'Coat', imagePath: 'coat' },
    { name: 'Dress', imagePath: 'dress' },
    { name: 'Shoe', imagePath: 'shoe' },
    { name: 'Raincoat', imagePath: 'raincoat' },
  ],

  'Fruits': [
    { name: 'Apple', imagePath: 'apple' },
    { name: 'Mango', imagePath: 'mango' },
    { name: 'Strawberry', imagePath: 'strawberry' },
    { name: 'Cherries', imagePath: 'cherries' },
    { name: 'Lemon', imagePath: 'lemon' },
  ],

  'Vegetables': [
    { name: 'Cabbage', imagePath: 'cabbage' },
    { name: 'Pea', imagePath: 'pea' },
    { name: 'Tomato', imagePath: 'tomato' },
  ],

  'Playground items': [
    { name: 'Swing', imagePath: 'swing' },
    { name: 'Slide', imagePath: 'slide' },
    { name: 'Monkey Bar', imagePath: 'monkeybar' },
  ],

  'Stationery': [
    { name: 'Pencil', imagePath: 'pencil' },
    { name: 'Pen', imagePath: 'pen' },
    { name: 'Scissors', imagePath: 'scissor' },
    { name: 'Glue', imagePath: 'glue' },
    { name: 'Marker', imagePath: 'marker' },
    { name: 'Crayon', imagePath: 'crayon' },
    { name: 'Book', imagePath: 'book' },
    { name: 'Paper', imagePath: 'paper' },
    { name: 'Pencil Case', imagePath: 'pencilcase' },
    { name: 'Calculator', imagePath: 'calculator' },
  ],

  'Furniture': [
    { name: 'Table', imagePath: 'table' },
    { name: 'Chair', imagePath: 'chair' },
    { name: 'Bed', imagePath: 'bed' },
    { name: 'Sofa', imagePath: 'sofa' },
    { name: 'Stool', imagePath: 'stool' },
    { name: 'Bench', imagePath: 'bench' },
  ],

  'Kitchen items': [
    { name: 'Pot', imagePath: 'pot' },
    { name: 'Pan', imagePath: 'pan' },
    { name: 'Chopping Board', imagePath: 'choppingboard' },
    { name: 'Sink', imagePath: 'sink' },
    { name: 'Oven', imagePath: 'oven' },
  ],

  'Bathroom items': [
    { name: 'Toilet', imagePath: 'toilet' },
    { name: 'Sink', imagePath: 'sink' },
    { name: 'Shower', imagePath: 'shower' },
    { name: 'Soap', imagePath: 'soap' },
    { name: 'Shampoo', imagePath: 'shampoo' },
    { name: 'Toothbrush', imagePath: 'toothbrush' },
    { name: 'Towel', imagePath: 'towel' },
  ],

  'Jewellery': [
    { name: 'Necklace', imagePath: 'necklace' },
    { name: 'Bracelet', imagePath: 'bracelet' },
    { name: 'Piercing', imagePath: 'piercing' },
  ],
};

// Helper function to get all classes
export function getAllClasses() {
  return Object.keys(CLASS_ASSET_MAPPINGS);
}

// Helper function to get assets for a specific class
export function getAssetsForClass(className) {
  return CLASS_ASSET_MAPPINGS[className] || [];
}

// Helper function to get all unique assets across all classes
export function getAllClassAssets() {
  const allAssets = new Map();
  Object.values(CLASS_ASSET_MAPPINGS).forEach(assets => {
    assets.forEach(asset => {
      allAssets.set(asset.imagePath, asset);
    });
  });
  return Array.from(allAssets.values());
}

// Helper function to convert to the format expected by Game 6
export function convertToGame6Format() {
  return Object.entries(CLASS_ASSET_MAPPINGS)
    .filter(([cls, assets]) => assets.length >= 3) // Only classes with 3+ items
    .map(([cls, assets]) => ({
      cls,
      items: assets.map(asset => asset.imagePath)
    }));
}

// Helper function to find what class(es) an asset belongs to
export function getClassesForAsset(imagePath) {
  const classes = [];
  Object.entries(CLASS_ASSET_MAPPINGS).forEach(([className, assets]) => {
    if (assets.some(asset => asset.imagePath === imagePath)) {
      classes.push(className);
    }
  });
  return classes;
}
